// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3q_vf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1w1Kg"};